export const invitations = {
  cta: {
    share: {
      data: {
        text: 'Hi! Ken jij Creative Shelter al? Ik factureer via hen mijn auteursrechten en hou zo meer centen over. Ook eens proberen? Factureer 60 dagen gratis en voor niets. (Nog meer overhouden dus!)',
        title: 'Het facturatieplatform van Creative Shelter',
      },
      permissionDenied: 'Je moet toestemming geven om je uitnodigingslink te kunnen delen.',
    },
    socials: {
      twitter: {
        hashtags: '#auteursrechten #meerverdienen #creativeshelter',
        text: 'Jij daar! Ken je Creative Shelter al? Ik factureer via hen mijn auteursrechten en hou zo meer centen over. Ook eens proberen? Factureer 60 dagen gratis en voor niets!',
      },
    },
  },
  discount: {
    ariaLabel: 'Voortgang korting: {{completed}} van {{total}} stappen voltooid',
  },
  discountProgress: {
    currentDiscount: 'Je ontvangt momenteel {{percentage}}% korting',
    hint_one: 'Nodig nog {{count}} vriend uit',
    hint_other: 'Nodig nog {{count}} vrienden uit',
    savedLabel: 'Je bespaarde al',
    step: '{{percentage}}% korting op je vergoeding',
  },
  hero: {
    buttons: {
      copyLink: 'Link kopiëren',
      copyLinkSuccess: 'Gekopieerd',
      email: 'Stuur een e-mail',
      share: 'Deel',
    },
    description:
      'Stuur je persoonlijke link door. Zodra je vriend/collega hun eerste factuur verstuurt, krijg jij 25% korting op je vergoeding aan Creative Shelter en je vriend factureert 60 dagen gratis.',
    shareVia: 'of deel via',
    socials: {
      facebook: 'Deel via Facebook',
      linkedin: 'Deel via LinkedIn',
      whatsapp: 'Deel via WhatsApp',
      x: 'Deel via X',
    },
    title: 'Nodig een vriend uit en krijg korting',
  },
  howItWorks: {
    disclaimer:
      'De korting van 25% is één jaar geldig en gaat in zodra de persoon die je uitnodigde een eerste factuur verstuurd heeft, binnen de 30 dagen na het aanmaken van een account. Voor de persoon die je uitnodigt, gaat de korting direct in na het aanmaken van hun account.',
    steps: {
      earn: 'Jij verdient 25% korting per vriend die factureert',
      invoice: 'Je vriend factureert 60 dagen lang gratis',
      register: 'Je vriend registreert zich met je persoonlijke link',
    },
    title: 'Hoe werkt het?',
  },
  sendInvitationDialog: {
    errors: {
      accountAlreadyExists: 'Deze freelancer factureert al via Creative Shelter. 🙌',
      noDoubleInvite: 'Je hebt al een uitnodiging naar dit e-mailadres verstuurd.',
      noSelfInvite: 'Je kan jezelf niet uitnodigen!',
      userAlreadyExists:
        'Deze freelancer heeft al een account bij Creative Shelter, maar factureert nog niet. Soms heeft iemand gewoon een duwtje in de rug nodig.',
    },
    form: {
      inviteeEmailAddressField: {
        label: 'E-mailadres',
      },
      inviteeFirstNameField: {
        label: 'Voornaam',
      },
      inviteeLanguageField: {
        label: 'Taal',
      },
      inviteeLastNameField: {
        label: 'Achternaam',
      },
      submitButton: 'Versturen',
    },
    success: 'Je uitnodiging is verstuurd naar {{ name }}.',
    title: 'Nodig iemand uit',
  },
  sentInvitations: {
    headers: {
      email: 'E-mail',
      name: 'Naam',
      status: 'Status',
    },
    status: {
      accepted: 'Geregistreerd',
      declined: 'Geweigerd',
      pending: 'In afwachting',
    },
    title: 'Verstuurde uitnodigingen',
  },
  title: 'Vrienden uitnodigen',
};
